import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import BankAccountBalanceMetricModel from './BankAccountBalanceMetricModel';
import BankAccountOverdraft from './BankAccountOverdraftModel';

const BankAccountMetricsRecord = Record({
  month: null,
  year: null,
  overdraft: null,
});

export default class BankAccountMetrics extends BankAccountMetricsRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      month: BankAccountBalanceMetricModel.deserialize,
      year: BankAccountBalanceMetricModel.deserialize,
      overdraft: BankAccountOverdraft.deserialize,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new BankAccountMetrics(hydrated);
  }

  get averageYearBalance() {
    return this.year ? this.year.average : null;
  }
}
